import {
  SPONSOR_SOGANG,
  SPONSOR_STARTLINK,
  SPONSOR_MOBIS,
  SPONSOR_SOLVEDAC,
} from "./sponsor";

export const CWC_2023 = {
  nth: 2,
  year: 2023,
  dateStr: "2023년 5월 20일(토) 오후 2시 ~ 오후 5시",
  location: "서강대학교 다산관(D관) D104, 105호",
  links: {
    boj: "https://www.acmicpc.net/category/847",
  },
  awards: {
    round: {
      newbie: [
        {
          rank: 1,
          variant: "gold",
          solved: 8,
          name: "박성준",
          bojHandle: "greedev",
        },
        {
          rank: 2,
          variant: "silver",
          solved: 6,
          name: "김주헌",
          bojHandle: "kjh1867",
        },
        {
          rank: 3,
          variant: "silver",
          solved: 5,
          name: "조다니엘",
          bojHandle: "arduinocc04",
        },
        {
          rank: 4,
          variant: "bronze",
          solved: 5,
          name: "이동규",
          bojHandle: "ldk3014",
        },
        {
          rank: 5,
          variant: "bronze",
          solved: 5,
          name: "이지훈",
          bojHandle: "hiyabye",
        },
        {
          rank: 6,
          variant: "bronze",
          solved: 4,
          name: "김다은",
          bojHandle: "splanky0314",
        },
      ],
      oldbie: [
        {
          rank: 1,
          variant: "gold",
          solved: 5,
          name: "임권영",
          bojHandle: "hiLimky",
        },
        {
          rank: 2,
          variant: "silver",
          solved: 5,
          name: "김명준",
          bojHandle: "audwns0820",
        },
        {
          rank: 3,
          variant: "silver",
          solved: 5,
          name: "윤정현",
          bojHandle: "alnca0103",
        },
        {
          rank: 4,
          variant: "bronze",
          solved: 4,
          name: "이하윤",
          bojHandle: "lhy100494",
        },
        {
          rank: 5,
          variant: "bronze",
          solved: 4,
          name: "박정원",
          bojHandle: "sanguineman",
        },
        {
          rank: 6,
          variant: "bronze",
          solved: 3,
          name: "고동헌",
          bojHandle: "rhehdtor",
        },
      ],
    },
  },
  examiners: [
    {
      name: "송근수",
      bojHandle: "hulahula3247",
      school: "서강대학교",
    },
    {
      name: "유호영",
      bojHandle: "tkfkddl59323",
      school: "서강대학교",
    },
    {
      name: "이민희",
      bojHandle: "minigimbob",
      school: "서강대학교",
    },
    {
      name: "이지훈",
      bojHandle: "maker29",
      school: "서강대학교",
    },
    {
      name: "정회윤",
      bojHandle: "yunny_world",
      school: "서강대학교",
    },
    {
      name: "채성우",
      bojHandle: "lem0nad3",
      school: "서강대학교",
    },
  ],
  checkers: [
    {
      name: "강효규",
      bojHandle: "djs100201",
      school: "서강대학교",
    },
    {
      name: "김동건",
      bojHandle: "dong_gas",
      school: "서강대학교",
    },
    {
      name: "김동규",
      bojHandle: "eaststar",
      school: "KAIST",
    },
    {
      name: "문정후",
      bojHandle: "mjhmjh1104",
      school: "KAIST",
    },
    {
      name: "박진식",
      bojHandle: "pjshwa",
      school: "클루미오",
    },
    {
      name: "주감동",
      bojHandle: "jthis",
      school: "국민대학교",
    },
  ],
  sponsors: [
    SPONSOR_SOGANG,
    SPONSOR_STARTLINK,
    SPONSOR_MOBIS,
    SPONSOR_SOLVEDAC,
  ],
};
